module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-primary is-fullheight",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Examples")]), _vm._v(" "), _c('sample', {
    attrs: {
      "title": "Simple Select",
      "desc": "Just a replace to the regular <select>"
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('bulma-select', {
    attrs: {
      "label": "name",
      "placeholder": "Select your team",
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_vm._v("<bulma-select\n  label=\"name\"\n  placeholder=\"Select your team\"\n  v-model=\"selection\"\n  :options=\"options\">\n</bulma-select>")])], 2), _vm._v(" "), _c('sample', {
    attrs: {
      "title": "Select with search",
      "desc": "Type to search in the options"
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('bulma-select', {
    attrs: {
      "label": "name",
      "placeholder": "Select your team",
      "search": true,
      "options": _vm.searched
    },
    on: {
      "type": _vm.search
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_vm._v("<bulma-select\n  label=\"name\"\n  placeholder=\"Select your team\"\n  v-model=\"selection\"\n  @type=\"search\"\n  :search=\"true\"\n  :options=\"options\">\n</bulma-select>")])], 2), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Documentation")]), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-center"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('h1', {
    staticClass: "title is-marginless"
  }, [_vm._v("Vue Bulma Select")]), _vm._v(" "), _c('h2', {
    staticClass: "title is-6"
  }, [_vm._v("Select components using Bulma as CSS framework")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sample__container"
  }, [_c('h3', {
    staticClass: "title is-4"
  }, [_vm._v("<bulma-select>")]), _vm._v(" "), _c('h4', {
    staticClass: "title is-6"
  }, [_vm._v("Properties")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("v-model")]), _vm._v(" "), _c('td', [_vm._v("Any")]), _vm._v(" "), _c('td', [_vm._v("Value selected.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Text that will be used as placeholder in the select.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Array[Any]")]), _vm._v(" "), _c('td', [_vm._v("Select options.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("If an Array of objects is passed as options, label is the object key that will be displayed.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("search")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("If it has search or not.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("maxItems")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("The max number of options that will be displayed.")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "title is-6"
  }, [_vm._v("Events")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Params")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("When the search field recive input.")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("text: String")]), _vm._v(" - the text inputed")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "title is-6"
  }, [_vm._v("Slots")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("no-results")]), _vm._v(" "), _c('td', [_vm._v("When there is no options its displayed on the options container.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-foot"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "has-text-centered is-fullwidth"
  }, [_vm._v("\n          Built by "), _c('a', {
    attrs: {
      "href": "https://github.com/gabrielcorado"
    }
  }, [_vm._v("@gabrielcorado")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bd8cf8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 48
// module chunks = 2